module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_troendelag_neg.4a63111f.svg";